import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Uncaught render error", error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="mx-auto max-w-md space-y-6 py-12 text-center">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100" data-testid="error-title">
          Error
        </h1>
        <CardContainer>
          <p className="text-sm text-gray-600 dark:text-gray-400">
            An error occurred while processing your request.
          </p>
        </CardContainer>
        <a
          href="/activities"
          className="text-sm text-emerald-700 hover:underline dark:text-emerald-400"
          data-testid="error-home-link"
        >
          Return to activities
        </a>
      </div>
    );
  }
}

function CardContainer({ children }: { children: ReactNode }) {
  return (
    <div className="rounded-lg border border-gray-200 bg-white p-6 shadow-sm dark:border-[#2e2e2e] dark:bg-[#1a1a1a]">
      {children}
    </div>
  );
}
